<template>
  <div v-if="authenticatedUser">
    <b-container>
      <!-- Successful Group Join modal -->
      <b-modal @ok="Reload" id="modal-1" ok-only title="Success">
        <p class="my-2">You have successfully joined this group!</p>
      </b-modal>
      <!-- Successful Group Member Acceptance modal -->
      <b-modal id="modal-2" ok-only title="Success">
        <p class="my-2">The applicant has been added to your group!</p>
      </b-modal>

      <b-modal id="modal-3" ok-only title="Success">
        <p class="my-2">The user has successfully become a member of this group!</p>
      </b-modal>

      <b-modal id="modal-4" ok-only title="Success">
        <p class="my-2">The user will become a member once she/he accepts the invitation!</p>
      </b-modal>
      <!--  modal Accept - Reject -->

      <b-modal
        @cancel="RejectCancel"

        @ok="AcceptOk"
        cancel-title="Reject"
        id="modal-9"
        ok-title="Accept"
        ok-variant="danger"
        title="Reply to applicants"
      >
        <p class="my-2">Whose request will you answer to?</p>
        <Autocomplete :EventBus="sendChosenLogin2"></Autocomplete>
      </b-modal>

      <!--  modal Invitation -->
      <b-modal
        @ok="handleInvitationOk"
        id="modal-invite"
        ok-title="Invite"
        ok-variant="danger"
        ref="modal"

        title="Invite someone to this group"
      >
        <p class="my-2">Whom do you wish to invite?</p>

        <!--  <b-form-group
            class="col-12"
            label="For which group will you give your consent?"
            label-align="left"
          >
            <textarea
              v-model="GroupNameConsent"
              class="col-12 form-control"
              rows="1"
              placeholder="Enter Group Name..."
            ></textarea>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="NoGroupAlert"
              variant="danger"
            >You have to specify the right!</b-alert>
          </b-form-group> -->
        <Autocomplete :EventBus="sendChosenLogin2"></Autocomplete>
      </b-modal>
      <!--  modal -->

      <b-modal
        @ok="handleOk"
        id="modal-Join"
        ok-title="Ask to Join"
        ok-variant="danger"

        ref="modal"
      >
        <b-form-group
          class="col-12"
          label="Enter the name of the Group you wish to join?"
          label-align="left"
        >
          <textarea
            class="col-12 form-control"
            placeholder="Enter Group Name..."
            rows="1"
            v-model="GroupName"
          ></textarea>
          <b-alert
            dismissible
            style="width: 100%"
            v-model="NoGroupAlert"
            variant="danger"
          >You have to specify the right!
          </b-alert>
        </b-form-group>
      </b-modal>

      <b-modal
        @ok="handleOk"
        cancel-title="Decline"
        id="modal-ReplyInvitations"
        ok-title="Accept Invitation"
        ok-variant="danger"

        ref="modal"
      >
        <b-form-group
          class="col-12"
          label="Enter the name of the Group you have been invited?"
          label-align="left"
        >
          <textarea
            class="col-12 form-control"
            placeholder="Enter Group Name..."
            rows="1"
            v-model="GroupName"
          ></textarea>
          <b-alert
            dismissible
            style="width: 100%"
            v-model="NoGroupAlert"
            variant="danger"
          >You have to specify the right!
          </b-alert>
        </b-form-group>
      </b-modal>

      <div class="mt-5 mb-3 ml-0 mr-0">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-row>
              <b-col class="col-7">
                <b-nav
                  card-header
                  pills
                >
                  <b-nav-item @click="showMyGroups" :class="selector ? 'active' : ''">
                    Groups I've created
                  </b-nav-item>
                  <b-nav-item @click="showPublicGroups" :class="!selector ? 'active' : ''">
                    Groups I've joined
                  </b-nav-item>
                </b-nav>
              </b-col>
              <b-col class="col-5">
                <div class="create-container float-right">
                  <a
                    class="btn-join"
                    @click="RequestToJoin"
                  >
                    <img
                      height="32"
                      src="/static/img/ic-feature-collaborate.png"
                    />
                    <span>Join Group</span>
                  </a>
                  <router-link
                    :to="{name: 'groupAdd'}"
                    class="btn-create"
                  >
                    <img
                      height="32"
                      src="/static/img/ic-feature-create.png"
                    />
                    <span>Create Group</span>
                  </router-link>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <hr class="my-0">
          <b-card-body class="text-center py-0">
            <!-- Own Groups -->

            <GroupSection :type1="ownGroups" id="my-Groups" v-show="selector"/>
            <!-- Public Groups -->
            <GroupSection :type1="publicGroups" id="public-Groups" v-show="!selector"/>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
  <div v-else>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <br/>
        <br/>
        <h3>
          <router-link :to="{name: 'home'}">Home page</router-link>
          |
          <router-link :to="{name: 'login'}">Login</router-link>
        </h3>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import GroupSection from '../components/groups/GroupsSection'
import axios from 'axios'
import Autocomplete from './Autocomplete'
import {eventBus} from '../main'

export default {
  name: 'Groups',
  data () {
    return {
      selector: true,
      publicGroups: 'PUBLIC',
      ownGroups: 'OWN',
      GroupName: '',
      GroupNameConsent: '',
      NoGroupAlert: false,
      userID: '',
      userID2: '',
      value1: '',
      value2: '',
      OWNER: '',
      groupToBeInvited: '',
      groupToBeAccepted: '',
      sendChosenLogin2: 'sendChosenLoginforInvitation'
    }
  },
  components: {
    GroupSection, Autocomplete
  },
  computed: {
    ...mapGetters(['authenticatedUser'])
  },
  created () {
    eventBus.$on('sendChosenLoginforConsent', value11 => {
      this.value1 = value11
    })

    eventBus.$on('sendChosenLoginforInvitation', value12 => {
      this.value2 = value12
    })

    axios
      .get('/user', {
        withCredentials: true
      })
      .then(response => {
        this.OWNER = response.data.id
      })

    eventBus.$on('sendgroupIDforAcceptReject', b => {
      this.groupToBeAccepted = b
      this.$bvModal.show('modal-9')
    })

    eventBus.$on('sendgroupIDforConsent', groupId => {
      this.groupToBeInvited = groupId
      this.$bvModal.show('modal-invite')
    })
  },
  methods: {
    Reload () {
      window.location.reload()
    },
    RequestToJoin () {
      this.$bvModal.show('modal-Join')
    },
    ReplyToInvitations () {
      this.$bvModal.show('modal-ReplyInvitations')
    },
    handleOk () {
      axios
        .get('/group/byName?name=' + this.GroupName, {
          withCredentials: true
        })
        .then(response => {
          axios
            .post('/group/memberAcceptGroup/' + response.data.id, null, {
              withCredentials: true
            })
            .then(response => {
              this.$bvModal.show('modal-1')
            })
            .catch(err => {
              this.$bvModal.show('modal-1')
            })
        })
        .catch(err => {

        })
    },
    AcceptOk () {
      axios
        .get('/user/byLogin?login=' + this.value2, {
          withCredentials: true
        })
        .then(response => {
          this.userID2 = response.data.id

          axios.post('/group/groupAcceptMember/' + this.groupToBeAccepted + '?userId=' + this.userID2, null, {
            withCredentials: true
          })
            .then(response => {
              this.$bvModal.show('modal-2')
            })
            .catch(err => {
              this.$bvModal.show('modal-2')
            })
        })
    },
    RejectCancel () {
      axios.post('/group/groupRejectMember/' + this.groupToBeAccepted + '?userId=' + this.userID2, null, {withCredentials: true})
        .then(response => {
        })
    },
    handleInvitationOk () {
      axios
        .get('/user/byLogin?login=' + this.value2, {
          withCredentials: true
        })
        .then(response => {
          this.userID2 = response.data.id

          axios
            .get('/group/' + this.groupToBeInvited, {
              withCredentials: true
            })
            .then(response => {
              var MemberConsent = response.data.needMemberConsent

              axios.post('/group/groupAcceptMember/' + this.groupToBeInvited + '?userId=' + this.userID2, null, {
                withCredentials: true
              })
                .then(response => {
                  if (MemberConsent === true) {
                    this.$bvModal.show('modal-4')
                  } else {
                    this.$bvModal.show('modal-3')
                  }
                })
                .catch(err => {
                  this.$bvModal.show('modal-2')
                })
            })
        })
    },
    showMyGroups () {
      this.selector = true
    },
    showPublicGroups () {
      this.selector = false
    }
  }
}
</script>

<style scoped>
  hr {
    margin-left: 20px;
    margin-right: 20px;
  }
  .card-header {
    background-color: #fff;
    padding: 20px 30px 16px 30px;
    border: 0;
  }
  .nav.nav-pills {
    height: 38px;
  }
  .nav-item {
    height: inherit;
    margin-right: 8px;
    background-color: #545b62;
    border-color: #545b62;
    border-radius: 5px;
  }
  .nav-item.active {
    background-color: #EE861D;
    border-color: #EE861D;
  }
  .nav-link {
    height: inherit;
    line-height: 22px;
    text-align: center;
    width:200px;
    color: #fff;
  }
  .btn-create {
    font-size: 14pt;
    margin-left: 14px;
  }
  .btn-create:hover {
    text-decoration: none;
    padding-right: 6px;
    margin-left: 8px;
  }
  .btn-join {
    font-size: 14pt;
    color: #EE861D !important;
  }
  .btn-join:hover {
    cursor: pointer;
    text-decoration: none;
    padding-right: 6px;
  }
  .create-container {
    margin-top: 3px;
    margin-left: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Groups.vue